import { makeStyles } from '@material-ui/core/styles';


export default makeStyles(theme => ({
    header: {
        background: '#E8E8E8',
        display: 'flex',
        alignItems: 'center',
        height: '49px',
        padding: '0px 0px 0 15px',
        "& h1": {
            padding: '0px 15px',
            fontSize: '22px',
            fontWeight: 600,
            lineHeight: '28.8px',
            color: '#2D4D95',
        }
    },
    statusBoxes: {
        position: 'relative',
        alignItems: 'inherit',
        width: '100%',
        borderRadius: '18px',
        padding: '6px 0px 0px 8px',
        margin: 'auto',
        display: 'flex',
        minHeight: '160px',
        justifyContent: 'center',
        width: '100%',
        alignItems: 'center',
        "& img": {
            padding: '0px 8px 0px 0px',
            marginLeft: 'auto',
            maxWidth: '53px',
        },
        "& h3": {
            color: 'white',
            fontSize: '25px',
            margin: '5px 0',
            display: 'flex',
            fontWeight: 500,
            alignItems: 'center',
        },
        "& h1": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '36px',
            lineHeight: '43px',
            display: 'flex',
            alignItems: 'center',
            color: '#FFFFFF',
            margin: '0 9px',
            justifyContent: 'right',
        }
    },
    gridHeader: {
        padding: '6px 15px',
        display: 'flex',
        flexFlow: 'wrap',
        alignItems: 'center',
        justifyContent: 'right',
    },
    gridActions: {
        textAlign: 'right',
        display: 'flex',
        alignItems: 'center',
        "& Button": {
            color: 'white',
            marginRight: '7px',
            textTransform: 'capitalize',
            background: '#454545 !important',
            padding: '7px 18px',
            margin: '5px',
            "& hover": {
                background: '#454545',
            }
        }
    },

    changeBtn: {
        fontSize: '14px',
        fontWeight: 500,
        cursor: 'pointer',
        backgroundColor: '#454545',
        borderRadius: '6px',
        marginRight: '5px',
        padding: '8px 16px',
        textTransform: 'capitalize',
        cursor: 'pointer',
        color: '#ffffff',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#5e5e5e',
        }
    },

    statusBoxContainer: {
        display: 'flex',
        marginBottom: '10px',
        width: '100%',
        flexFlow: 'wrap',
        "& .Total": {
            background: "linear-gradient(135deg, #7563A8 0%, #624E92 100%)",
            border: "1px solid #624E92",

            "& span": {
                fontSize: "35px",
                color: "white",
            },
            "& h3": {
                color: "white",
            }
        },

        "& .Total:hover": {
            boxShadow: "0px 4px 12px rgba(98, 78, 146, 0.25)",
            backgroundImage: "linear-gradient(135deg, #806DB2 0%, #6A559A 100%)",
            backgroundRepeat: "no-repeat",
            position: "relative",

            "& span": {
                fontSize: "35px",
                color: "white",
            },
            "& h3": {
                color: "white",
            }
        },

        "& .Mui-checked + span > .Total": {
            boxShadow: "0px 4px 12px rgba(98, 78, 146, 0.25)",
            backgroundImage: "linear-gradient(135deg, #806DB2 0%, #6A559A 100%)",
            backgroundRepeat: "no-repeat",
            position: "relative",

            "& span": {
                fontSize: "35px",
                color: "white",
            },
            "& h3": {
                color: "white",
            }
        },

        "& .Mui-checked + span > .Total::before": {
            content: "'✔'",
            fontSize: "19px",
            fontWeight: "bolder",
            color: "#3F8F68",
            display: "inline-block",
            width: "25px",
            height: "25px",
            position: "absolute",
            background: "white",
            right: 5,
            top: 5,
            borderRadius: "50px",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
        },

        "& .Mui-checked + span > .Total>span": {
            fontSize: "35px",
            color: "white",
        },

        "& .Mui-checked + span > .Total>h3": {
            color: "white",
        },


        /* =========================
           PENDING / GREEN
        ========================= */

        "& .Pending": {
            background: "linear-gradient(135deg, #4B9873 0%, #397E5C 100%)",
            border: "1px solid #397E5C",

            "& span": {
                fontSize: "35px",
                color: "white",
            },
            "& h3": {
                color: "white",
            }
        },

        "& .Mui-checked + span > .Pending": {
            boxShadow: "0px 4px 12px rgba(57, 126, 92, 0.25)",
            backgroundImage: "linear-gradient(135deg, #559F7C 0%, #418766 100%)",
            backgroundRepeat: "no-repeat",
            position: "relative",

            "& span": {
                fontSize: "35px",
                color: "white",
            },
            "& h3": {
                color: "white",
            }
        },

        "& .Mui-checked + span > .Pending::before": {
            content: "'✔'",
            fontSize: "19px",
            fontWeight: "bolder",
            color: "#3F8F68",
            display: "inline-block",
            width: "25px",
            height: "25px",
            position: "absolute",
            background: "white",
            right: 5,
            top: 5,
            borderRadius: "50px",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
        },

        "& .Pending:hover": {
            boxShadow: "0px 4px 12px rgba(57, 126, 92, 0.25)",
            backgroundImage: "linear-gradient(135deg, #559F7C 0%, #418766 100%)",
            backgroundRepeat: "no-repeat",

            "& span": {
                fontSize: "35px",
                color: "white",
            },
            "& h3": {
                color: "white",
            }
        },


        /* =========================
           DELIVERED / BLUE
        ========================= */

        "& .Delivered": {
            background: "linear-gradient(135deg, #5879B0 0%, #456397 100%)",
            border: "1px solid #456397",

            "& span": {
                fontSize: "35px",
                color: "white",
            },
            "& h3": {
                color: "white",
            }
        },

        "& .Mui-checked + span > .Delivered": {
            boxShadow: "0px 4px 12px rgba(69, 99, 151, 0.25)",
            backgroundImage: "linear-gradient(135deg, #6383B8 0%, #4D6DA0 100%)",
            backgroundRepeat: "no-repeat",
            position: "relative",

            "& span": {
                fontSize: "35px",
                color: "white",
            },
            "& h3": {
                color: "white",
            }
        },

        "& .Mui-checked + span > .Delivered::before": {
            content: "'✔'",
            fontSize: "19px",
            fontWeight: "bolder",
            color: "#3F8F68",
            display: "inline-block",
            width: "25px",
            height: "25px",
            position: "absolute",
            background: "white",
            right: 5,
            top: 5,
            borderRadius: "50px",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
        },

        "& .Delivered:hover": {
            boxShadow: "0px 4px 12px rgba(69, 99, 151, 0.25)",
            backgroundImage: "linear-gradient(135deg, #6383B8 0%, #4D6DA0 100%)",
            backgroundRepeat: "no-repeat",

            "& span": {
                fontSize: "35px",
                color: "white",
            },
            "& h3": {
                color: "white",
            }
        },



        "& .Enrolled": {
            background: '#ffdfb1',
            border: '1px solid #f0bd73',
            "& span": {
                fontSize: '35px',
                color: '#a97c3b',
            },
            "& h3": {
                color: '#a97c3b',
            }
        },
        "& .Mui-checked + span > .Enrolled": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #D6B482 0%, #6F4200 100%)',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
            "& span": {
                fontSize: '35px',
                color: 'white',
            },
            "& h3": {
                color: 'white',
            }
        },
        "& .Mui-checked + span > .Enrolled::before": {
            content: "'✔'",
            fontSize: '19px',
            fontWeight: 'bolder',
            color: '#01da01',
            display: 'inline-block',
            width: '25px',
            height: '25px',
            position: 'absolute',
            background: 'white',
            right: 5,
            top: 5,
            borderRadius: '50px',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
        },
        "& .Enrolled:hover": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #D6B482 0%, #6F4200 100%);',
            backgroundRepeat: 'no-repeat',
            "& span": {
                fontSize: '35px',
                color: 'white',
            },
            "& h3": {
                color: 'white',
            }
        },

        "& .Rejected": {
            background: '#ff300f',
            border: '1px solid #514343',
            "& span": {
                fontSize: '35px',
                color: '#ffffff',
            },
            "& h3": {
                color: '#ffffff',
            }
        },
        "& .Mui-checked + span > .Rejected": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #ff0000  0%, #340000  100%);',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
            "& span": {
                fontSize: '35px',
                color: 'white',
            },
            "& h3": {
                color: 'white',
            }
        },
        "& .Mui-checked + span > .Rejected::before": {
            content: "'✔'",
            fontSize: '19px',
            fontWeight: 'bolder',
            color: '#01da01',
            display: 'inline-block',
            width: '25px',
            height: '25px',
            position: 'absolute',
            background: 'white',
            right: 5,
            top: 5,
            borderRadius: '50px',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
        },
        "& .Rejected:hover": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #ff0000  0%, #340000  100%);',
            backgroundRepeat: 'no-repeat',
            "& span": {
                fontSize: '35px',
                color: 'white',
            },
            "& h3": {
                color: 'white',
            }
        },

        "& .MuiCheckbox-colorPrimary": {
            position: 'absolute',
        }
    },
    statusBoxInfo: {

    },
    checkBoxFormLabel: {
        margin: '0px 2px 5px 2px',
        width: window.isMobileView ? '28%' : '28%',
    },
    checkBoxBtn: {
        marginLeft: "0px",
        paddingRight: "5px",
        "& + .MuiFormControlLabel-label": {
            color: "#52575C",
            fontSize: "14px",
            width: '100%',
        },
        "& .MuiSvgIcon-root": {
            opacity: 0,
            display: 'none',
        }
    },
    statusBoxContent: {
        width: "100%",
        height: "100%",

        display: "flex",
        alignItems: "baseline",
        flexFlow: 'column',
        padding: "12px 16px",
        boxSizing: "border-box",

        gap: "15px",
        "& h2": {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '36px',
            display: 'flex',
            alignItems: 'center',
            margin: 0,
            color: 'white',
            justifyContent: 'right',
            marginRight: '9px',
        },
        "& h5": {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            margin: 0,
            color: '#10B921',
        },

    },
    statusBoxIcon: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        "& img": {
            width: "55px",
            height: "55px",
            objectFit: "contain",
            margin: 'auto',
            padding: 0,
        },
    },

    statusBoxInfo: {
        flex: 1,
        minWidth: 300,

        display: "flex",
        flexDirection: "column",

        gap: "12px",
    },

    statusBoxItemSecond: {
        width: "100%",
        minWidth: 0,
        borderBottom: '1px solid #fae2d926',
        paddingBottom: '12px',
        display: "grid",

        // Label on left, amount on right
        gridTemplateColumns: "minmax(0, 1fr) auto",

        alignItems: "center",

        columnGap: "12px",

        padding: "2px 0",

        "& span": {
            minWidth: 0,

            fontSize: "20px !important",
            fontWeight: 700,

            lineHeight: 1.15,

            color: "#FFFFFF",

            overflowWrap: "break-word",
        },


        "& h2": {
            margin: 0,

            fontSize: "28px",
            fontWeight: 700,

            lineHeight: 1,

            color: "#172B4D",

            whiteSpace: "nowrap",
        },

        "& + &": {
            paddingTop: "14px",

            borderTop: "1px solid rgba(255, 255, 255, 0.18)",
        },
    },

    statusBoxItemfirst: {
        width: "100%",
        minWidth: 0,

        display: "grid",

        // Label on left, amount on right
        gridTemplateColumns: "minmax(0, 1fr) auto",

        alignItems: "center",

        columnGap: "12px",

        padding: "2px 0",

        "& span": {
            minWidth: 0,

            fontSize: "17px !important",
            fontWeight: 400,

            lineHeight: 1.15,

            color: "#FFFFFF",

            overflowWrap: "break-word",
        },


        "& h2": {
            margin: 0,

            fontSize: "20px",
            fontWeight: 400,

            lineHeight: 1,

            color: "#172B4D",

            whiteSpace: "nowrap",
        },

        "& + &": {
            paddingTop: "14px",

            borderTop: "1px solid rgba(255, 255, 255, 0.18)",
        },
    },
    distributedDevicesCount: {
        position: 'absolute',
        right: '10px',
        bottom: '8px',
        fontSize: '13px',
        fontWeight: 400,
        color: 'white',
        textAlign: 'right',
        '& strong': {
            fontSize: '18px',
            fontWeight: 700,
        },
    },
    heading: {
        fontWeight: 700,
        fontSize: '20px',
        margin: '0px',
        color: '#3C4549',
    },
    container: {
        padding: '6px 15px',
    },


    legend: {
        display: 'flex',
        //alignItems: 'center',
        gap: '8px'
    },
    colorIndicator: {
        width: '1rem',
        height: '1rem',

    },



}));
